const minLength: number = 9
const maxLength: number = 20
const minCountNumbers: number = 1
const minCountUpperChars: number = 1
const minCountLowerChars: number = 1
const minCountSpecialSigns: number = 1

export {
    minLength,
    maxLength,
    minCountNumbers,
    minCountUpperChars,
    minCountLowerChars,
    minCountSpecialSigns
}
